import { RootState } from 'store';

import { STATE } from '../types/state';

import { TIsLoading } from '../types/isLoading';

const selector = (state: RootState): TIsLoading => {
  const { isLoading } = state[STATE];
  return isLoading;
};

export default selector;
